module.exports = __webpack_public_path__ + "img/archive-light.6e89a85c.png";